import { environment } from 'src/environments/environment';
import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { TransactionService } from '../../services/transaction.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VariableService } from 'src/app/services/variable.service';
import { ProfileService } from "../../services/profile.service";
import { isNullOrUndefined } from 'src/app/validation';
import { Session } from 'protractor';
declare var $: any;

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @Input() OpenModel: boolean;
  @Output() OnOTP: EventEmitter<any> = new EventEmitter()
  @Output() CallResendOTP: EventEmitter<any> = new EventEmitter()
  OTPForm: FormGroup;
  OTPFormSubmitted: boolean = false;
  G_ClientBasicInfoId: string;
  OtpTimer: number = 180;
  OtpTimeRemening: any = "03:00";
  OTP_Timer_Function: any;
  MobileNo: string = '';
  EmailID: string = '';
  CompanyName: string = '';
  ShowOTP: boolean = false;
  config: any = {
    length: 6,
    inputClass: 'OTPBox',
    allowNumbersOnly: true,
    inputStyles: {
      'text-security': 'disc',
      '-webkit-text-security': 'disc',
      '-moz-text-security': 'disc'
    }
  }
  //Added By Devang Mehta On 25-01-2025
  DisplayOTPSentText:any = "";
  TxStatus:any;
  rid = "";
  //End By Devang Mehta
  constructor(private fb: FormBuilder,
    private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService,
    private transaction: TransactionService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private profileService: ProfileService,
    private appVariable: VariableService,
    private clientProfileService: ProfileService) {

    this.OTPForm = this.fb.group({
      OTP: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  G_SubBrokerId: any
  // UserType : any =  parseInt(
  //   this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0"))
  // );
  UserType: number = 0;


  ngOnInit() {
    debugger
    this.Loader.show();

    if (sessionStorage.getItem("OTPRequestID") != null && sessionStorage.getItem("OTPRequestID") != undefined) {
      this.rid = sessionStorage.getItem("OTPRequestID");
      sessionStorage.removeItem("OTPRequestID");
    }

    if (sessionStorage.getItem("L2D3506kIHSk3E0") != null && sessionStorage.getItem("L2D3506kIHSk3E0") != undefined) {
      this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0")));
    }

    this.StartTimer();
    let MobileNumber = sessionStorage.getItem('mobdfghj');
    let Emailddress = sessionStorage.getItem('embdfghj');

    if (MobileNumber != null && MobileNumber != '' && MobileNumber != undefined) {

      this.appVariable.MobileNo = MobileNumber;
    }
    if (Emailddress != null && Emailddress != '' && Emailddress != undefined) {

      this.appVariable.EmailId = Emailddress;
    }
    this.CompanyName = environment.CompayName;
    var loaderInterval = setInterval(() => {
      let str = document.readyState;
      if (str == 'complete') {
        if (this.appVariable.MobileNo != null && this.appVariable.MobileNo != '' && this.appVariable.MobileNo != undefined) {
          this.MobileNo = this.ValueMasking(this.appVariable.MobileNo, "Mobile");
        }
        if (this.appVariable.EmailId != null && this.appVariable.EmailId != '' && this.appVariable.EmailId != undefined) {
          this.EmailID = this.ValueMasking(this.appVariable.EmailId, "Email");
        }
        console.log(this.MobileNo);
        clearInterval(loaderInterval)
      }
    }, 1000);

    if (this.UserType == 3) {
      let tempClientBasicInfoId = sessionStorage.getItem("N1QJHdOkO7Hz8QC");

      if (tempClientBasicInfoId != null && tempClientBasicInfoId != undefined) {
        this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(
          sessionStorage.getItem("N1QJHdOkO7Hz8QC")
        );
      }
      if (
        this.G_ClientBasicInfoId == null ||
        this.G_ClientBasicInfoId == "" ||
        this.G_ClientBasicInfoId == undefined
      ) {
        this.G_ClientBasicInfoId = sessionStorage.getItem(
          "KgxufWuE7G2cMlZTfzX"
        );
      }
    } else {
      let tempClientBasicInfoId = sessionStorage.getItem("sdfgr2342eedsdfsr");

      if (tempClientBasicInfoId != null && tempClientBasicInfoId != undefined) {
        this.G_ClientBasicInfoId = sessionStorage.getItem("sdfgr2342eedsdfsr");
      }
      else if (!isNullOrUndefined(sessionStorage.getItem('N1QJHdOkO7Hz8QC'))) {
        this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('N1QJHdOkO7Hz8QC'));
      }
    }

    setTimeout(() => {
      if (sessionStorage.getItem("Xe222SRRyYEoOC2") != null && sessionStorage.getItem("Xe222SRRyYEoOC2") != undefined) {
        this.MobileNo = this.ValueMasking(sessionStorage.getItem("Xe222SRRyYEoOC2"), "Mobile");
      }
      //Addded By Devang mehta on 25-01-2025
      if(!isNullOrUndefined(sessionStorage.getItem("dPkqx7ORCn6ZZpWFPN9U")) && sessionStorage.getItem("dPkqx7ORCn6ZZpWFPN9U") != ""){
        this.DisplayOTPSentText = sessionStorage.getItem("dPkqx7ORCn6ZZpWFPN9U");
      }
      if(!isNullOrUndefined(sessionStorage.getItem("abcxyz")) && sessionStorage.getItem("abcxyz") != ""){
        this.EmailID = this.ValueMasking(sessionStorage.getItem("abcxyz"),"Email");
      }
    }, 1500);
    //End By Devang Mehta
    //;
  }
  get o() {
    return this.OTPForm.controls;
  }
  ResetOTP() {
    this.bsModalRef.hide();
    this.ClearIntervalOTP()
  }
  ToggleOTPVisibility() {
    this.ShowOTP = !this.ShowOTP;
    this.config = {
      ...this.config,
      inputStyles: this.ShowOTP ? {} : {
        'text-security': 'disc',
        '-webkit-text-security': 'disc',
        '-moz-text-security': 'disc'
      }
    };
  }
  ClearIntervalOTP() {
    this.ngOtpInput.setValue('');
    $('#Time').text(this.OtpTimeRemening);

    clearInterval(this.OTP_Timer_Function);
  }
  onSubmitOTP() {
    debugger
    this.Loader.show();
    if (sessionStorage.getItem('MjTFLjHtTGH86dfjh') == 'FDVerification') {
      const request = {
        "VERIFICATION_ID": this.G_ClientBasicInfoId,
        "Trans_Type": 'FDVerification',
        "Flag": "V",
        "OTP": this.OTPForm.controls['OTP'].value
      };
      var json = JSON.stringify(request);
      this.clientProfileService.SendOTP(json, this.rid).subscribe(response => {
        debugger;
        let data = JSON.parse(this.EncrdecrService.getDecr(response))
        if (data.Message == "Verified") {// && id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value
          this.Loader.hide();
          this.bsModalRef.content.onClose.next(true);
          this.bsModalRef.hide();
          this.ClearIntervalOTP();
        }
        else {
          this.Loader.hide();
          this.ngOtpInput.setValue('');;
          this.CallAlertModal("Invalid OTP Code");
        }
      });
    }
    else if (sessionStorage.getItem('BOwGP96c1UGLzlHtJbEgXg==') == 'VerifyingOTP') {
      let communicationType = sessionStorage.getItem('kiMglaoQzUmzR0/wkTjFAw==');
      // const request = {
      //   "ClientBasicInfoId": this.EncrdecrService.setEncr(this.G_ClientBasicInfoId),
      //   "Flag": this.EncrdecrService.setEncr("V"),
      //   "OTP": this.EncrdecrService.setEncr(this.OTPForm.controls['OTP'].value)
      // };
      // const json = JSON.stringify(request);
      let request: any;
      if (communicationType == "M") {
        let mob = sessionStorage.getItem('mobdfghj');
        if (mob.startsWith('+91')) {
          mob = this.splitPhoneNumber(mob);
        }
        console.log("mob", mob);
        request = {
          Trans_Type: "Mobile",
          Flag: "V",
          ClientBasicinfoId: this.G_ClientBasicInfoId,
          MobileNo: mob,
          OTP: this.OTPForm.controls['OTP'].value
        };
      }
      else {
        request = {
          Trans_Type: "EmailID",
          Flag: "V",
          ClientBasicinfoId: this.G_ClientBasicInfoId,
          EmailId: sessionStorage.getItem('embdfghj'),
          OTP: this.OTPForm.controls['OTP'].value
        };
      }
      let dataBody = JSON.stringify(request);
      console.log('Request', dataBody)
      this.clientProfileService.SendOTP(dataBody, this.rid).subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));

        let code = this.EncrdecrService.getDecr(data.Message);
        console.log("Final data", code);
        let msg = code.split('|')[0];
        let SecreteCode = code.split('|')[2];
        console.log("OTP", this.OTPForm.controls["OTP"].value);
        if (msg == "Verified") {
          this.Loader.hide();
          this.bsModalRef.content.onClose.next(true);
          this.bsModalRef.hide();
          this.ClearIntervalOTP();
        }
        else {
          this.Loader.hide();
          this.ngOtpInput.setValue('');;
          this.CallAlertModal("Invalid OTP Code");
        }

      });
    }
    else if (sessionStorage.getItem('drfgthrve54recsdv') == 'FolioMobile' || sessionStorage.getItem('drfgthrve54recsdv') == 'UCCMobile') {
      let request: any;
      let TxStatus: any;
      if (!isNullOrUndefined(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM")) && sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM")) {
        TxStatus = this.EncrdecrService.getDecr(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM"));
        if (TxStatus == 1) {
          //Added By Devang Mehta on 27-01-2025
          if(!isNullOrUndefined(this.DisplayOTPSentText) && this.DisplayOTPSentText != ""){
            if(this.DisplayOTPSentText == "showBoth" || this.DisplayOTPSentText == "showMobile"){
              if (!isNullOrUndefined(sessionStorage.getItem("Xe222SRRyYEoOC2")) && sessionStorage.getItem("Xe222SRRyYEoOC2") != "") {
                request = {
                  Trans_Type: "Mobile",
                  Flag: "V",
                  ClientBasicinfoId: 0,
                  MobileNo: sessionStorage.getItem("Xe222SRRyYEoOC2"),
                  OTP: this.OTPForm.controls['OTP'].value
                };
              }
            }
            else{
              if(!isNullOrUndefined(sessionStorage.getItem("abcxyz")) && sessionStorage.getItem("abcxyz") != ""){
                request = {
                  Trans_Type: "EmailID",
                  Flag: "V",
                  ClientBasicinfoId: 0,
                  EmailId: sessionStorage.getItem("abcxyz"),
                  OTP: this.OTPForm.controls['OTP'].value
                };
              }
            }
          }
          else{
            if (!isNullOrUndefined(sessionStorage.getItem("Xe222SRRyYEoOC2")) && sessionStorage.getItem("Xe222SRRyYEoOC2") != "") {
              request = {
                Trans_Type: "Mobile",
                Flag: "V",
                ClientBasicinfoId: 0,
                MobileNo: sessionStorage.getItem("Xe222SRRyYEoOC2"),
                OTP: this.OTPForm.controls['OTP'].value
              };
            }
          }
          //End By Devang Mehta
        }
        else if (TxStatus == 21 || TxStatus == 24) {
          request = {
            Trans_Type: "EmailID",
            Flag: "V",
            ClientBasicinfoId: 0,
            EmailId: sessionStorage.getItem("abcxyz"),
            OTP: this.OTPForm.controls['OTP'].value
          };
        }
        else {
          //Added By Devang Mehta on 27-01-2025
          if(!isNullOrUndefined(this.DisplayOTPSentText) && this.DisplayOTPSentText != ""){
            if(this.DisplayOTPSentText == "showBoth" || this.DisplayOTPSentText == "showMobile"){
              if (!isNullOrUndefined(sessionStorage.getItem("Xe222SRRyYEoOC2")) && sessionStorage.getItem("Xe222SRRyYEoOC2") != "") {
                request = {
                  Trans_Type: "Mobile",
                  Flag: "V",
                  ClientBasicinfoId: 0,
                  MobileNo: sessionStorage.getItem("Xe222SRRyYEoOC2"),
                  OTP: this.OTPForm.controls['OTP'].value
                };
              }
            }
            else{
              if(!isNullOrUndefined(sessionStorage.getItem("abcxyz")) && sessionStorage.getItem("abcxyz") != ""){
                request = {
                  Trans_Type: "EmailID",
                  Flag: "V",
                  ClientBasicinfoId: 0,
                  EmailId: sessionStorage.getItem("abcxyz"),
                  OTP: this.OTPForm.controls['OTP'].value
                };
              }
            }
          }
          else{
            if (!isNullOrUndefined(sessionStorage.getItem("Xe222SRRyYEoOC2")) && sessionStorage.getItem("Xe222SRRyYEoOC2") != "") {
              request = {
                Trans_Type: "Mobile",
                Flag: "V",
                ClientBasicinfoId: 0,
                MobileNo: sessionStorage.getItem("Xe222SRRyYEoOC2"),
                OTP: this.OTPForm.controls['OTP'].value
              };
            }
          }
          //End By Devang Mehta
        }

        const json = JSON.stringify(request);
        this.clientProfileService.SendOTP(json, this.rid).subscribe(data => {
          let JSONRes = JSON.parse(this.EncrdecrService.getDecr(data));
          console.log("JSONres: " + JSON.stringify(JSONRes));
          let code = this.EncrdecrService.getDecr(JSONRes.reference_id);
          let id = code.split('|')[0];
          let SecreteCode = code.split('v')[1];
          if (id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value) {
            this.Loader.hide();
            this.bsModalRef.content.onClose.next(true);
            this.bsModalRef.hide();
            this.ClearIntervalOTP();
          }
          else {
            this.Loader.hide();
            this.ngOtpInput.setValue('');;
            this.CallAlertModal("Invalid OTP Code");
          }
        });
      }
    }
    else if(sessionStorage.getItem("dPkqx7ORCn6ZZpWFPN9U") == "showEmail"){
      let request = {
        Trans_Type: "EmailID",
        Flag: "V",
        ClientBasicinfoId: 0,
        EmailId: sessionStorage.getItem("abcxyz"),
        OTP: this.OTPForm.controls['OTP'].value
      };
      const json = JSON.stringify(request);
        this.clientProfileService.SendOTP(json, this.rid).subscribe(data => {
          let JSONRes = JSON.parse(this.EncrdecrService.getDecr(data));
          console.log("JSONres: " + JSON.stringify(JSONRes));
          let code = this.EncrdecrService.getDecr(JSONRes.reference_id);
          let id = code.split('|')[0];
          let SecreteCode = code.split('v')[1];
          if (id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value) {
            this.Loader.hide();
            this.bsModalRef.content.onClose.next(true);
            this.bsModalRef.hide();
            this.ClearIntervalOTP();
          }
          else {
            this.Loader.hide();
            this.ngOtpInput.setValue('');;
            this.CallAlertModal("Invalid OTP Code");
          }
        });
    }
    else if (sessionStorage.getItem("pterdfgo") == "STP" || sessionStorage.getItem("pterdfgo") == "SWP") {
      let requestData = {
        "VERIFICATION_ID": 'XSIPCANCELLATIONNEW',
        "USER_TYPE": "3",
        "MobileNo": sessionStorage.getItem("mobdfghj"),
        "EmailId": sessionStorage.getItem("embdfghj"),
        "Trans_Type": "Mobile",
        "Flag": sessionStorage.getItem("fglafghj"),
        "CLIENT_ID": sessionStorage.getItem("clbdfdi"),
        "UCCCode": sessionStorage.getItem("eitdfdec"),
        "SipRegNo": sessionStorage.getItem("gnordfgh"),
        "ReportType": sessionStorage.getItem("pterdfgo"),
        "OTP": parseInt(this.OTPForm.controls['OTP'].value)
      };
      // const json = JSON.stringify(request);
      this.profileService.SendOTPSIP(JSON.stringify(requestData)).subscribe(
        (res: any) => {
          this.Loader.hide();
          let result = JSON.parse(this.EncrdecrService.getDecr(res))
          if (result != null && result != undefined && result != '') {
            if (result.Message && result.Message != null && result.Message != undefined && result.Message != '') {

              if (result.Message == 'Verified') {
                this.Loader.hide();
                this.bsModalRef.content.onClose.next(true);
                this.bsModalRef.hide();
                this.ClearIntervalOTP();
              }
              else if (result.Message == 'Failed') {
                this.ClearIntervalOTP();
                this.ngOtpInput.setValue('');
                this.CallAlertModal("Something went wrong please try again later.");
              }
              else {
                this.Loader.hide();
                this.ngOtpInput.setValue('');
                this.CallAlertModal("Invalid OTP Code");
              }
              // if (result.Message == 'Success') {
              //   this.isOtpSent = false;
              //   this.isOtpVerfied = false;
              //   //$("#STPSWPVeifyOtp").modal({ backdrop: "static", keyboard: false, });
              //   sessionStorage.setItem('mobdfghj', this.ClientMoblieNo);
              //   sessionStorage.setItem('embdfghj', this.ClientEmailId);
              //   sessionStorage.setItem('fglafghj', flag);
              //   sessionStorage.setItem('clbdfdi', CLIENT_ID);
              //   sessionStorage.setItem('eitdfdec', this.Client_Code);
              //   sessionStorage.setItem('gnordfgh', commaSeparatedSipRegNo);
              //   sessionStorage.setItem('pterdfgo', this.ReportType);
  
  
              //   this.bsModelRef = this.bsModelService.show(OtpComponent, {
              //     class: "modal-dialog-centered modal-lg modal_otp",
              //     ignoreBackdropClick: true
              //   });
              //   this.bsModelRef.content.onClose = new Subject<boolean>();
              //   this.bsModelRef.content.action = new Subject<boolean>();
              //   this.bsModelRef.content.onClose.subscribe(res => {
              //     if (res == true) {
              //       sessionStorage.removeItem("Xe222SRRyYEoOC2");
              //       sessionStorage.removeItem("sdfgr2342eedsdfsr");
              //       sessionStorage.removeItem("sdfgr2342eedsdfsrEMAIL");
  
              //       if (this.ReportType == "CancelSTP") {
              //         this.ProceedToPayment();
              //       }
              //       else {
              //         //this.ProceedPauseSIP();
              //       }
              //       //}
              //     }
              //   });
              //   this.bsModelRef.content.action.subscribe(res => {
              //     if (res == true) {
              //       //this.ResendOTP();
              //       // this.SendOTPJM();
              //     }
              //   });
                
              //   // this.StartTimer();
              //   console.log(result);
              //   this.isSubmit = true;
              //   console.log(this.EncrdecrService.getDecr(result))
              // }
              // else if (result.Message == 'Overlimit') {
              //   // $("#SIPCancellationAction_new").modal("hide");
              //   // $("#STPSWPCancellationAction_new").modal("hide");
              //   this.isSubmit = true
              //   this.CallAlertModal(result.Message);
              // }
              // else if (result.Message == 'Invalid OTP Code') {
              //   this.CallAlertModal(result.Message);
              //   this.isOtpVerfied = true;
              //   this.isOtpSent = true;
              //   this.ngOtpInput.setValue("");
              //   this.ngOtpInput1.setValue("");
              //   //  this.isSubmit=false
              //   // this.ClearIntervalOTP();
              // }
              // else if (result.Message == 'OTP Code is Expired') {
              //   // $("#SIPCancellationAction_new").modal("hide");
              //   // $("#STPSWPCancellationAction_new").modal("hide");
              //   this.CallAlertModal(result.Message);
              //   //this.isOtpVerfied =true;
              //   this.isOtpSent = true;
              //   //  this.isSubmit=false
              //   //this.ClearIntervalOTP();
              //   //this.OTPBtnText="OTP Code is Expired";
              // }
              // else if (result.Message == 'Verified') {
              //   $(".res").addClass("act_verified").prop("disabled", true);
              //   this.OTPBtnText = "Verified";
              //   this.isOtpVerfied = true;
              //   this.isOtpSent = false;
              //   this.isSubmit = false
              //   this.OnClickSubmit();
              // }
              // else if (result.Message == 'Failed') {
              //   this.ClearIntervalOTP();
              //   //  $("#SIPCancellationAction_new").modal("hide");
              //   //  $("#STPSWPCancellationAction_new").modal("hide");
              //   this.CallAlertModal("Something went wrong please try again later.");
              // }
            }
          }
        },
        (err: any) => {
          this.Loader.hide();
          console.error("OTP err", err);
        }
      );


      // this.clientProfileService.SendOTP(json, this.rid).subscribe(data => {
      //   let JSONRes = JSON.parse(this.EncrdecrService.getDecr(data));
      //   console.log("JSONres: " + JSON.stringify(JSONRes));
      //   let code = this.EncrdecrService.getDecr(JSONRes.reference_id);
      //   let id = code.split('|')[0];
      //   let SecreteCode = code.split('v')[1];
      //   if (id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value) {
      //     this.Loader.hide();
      //     this.bsModalRef.content.onClose.next(true);
      //     this.bsModalRef.hide();
      //     this.ClearIntervalOTP();
      //   }
      //   else {
      //     this.Loader.hide();
      //     this.ngOtpInput.setValue('');;
      //     this.CallAlertModal("Invalid OTP Code");
      //   }
      // });
    }
    else {
      debugger
      if (!isNullOrUndefined(sessionStorage.getItem("rfrg343")) && sessionStorage.getItem("rfrg343") != "" && sessionStorage.getItem("rfrg343") != undefined) {
        this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem("cEdfUlqoNK").toString());
      }
      if (sessionStorage.getItem('UZT6qHaDZSz66kx') != null && sessionStorage.getItem('UZT6qHaDZSz66kx') != undefined) {
        this.G_ClientBasicInfoId = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem("UZT6qHaDZSz66kx"))).toString();
  
      }
      const request = {
        "ClientBasicInfoId": this.EncrdecrService.setEncr(this.G_ClientBasicInfoId),
        "Flag": this.EncrdecrService.setEncr("V"),
        "OTP": this.EncrdecrService.setEncr(this.OTPForm.controls['OTP'].value)
      };
      const json = JSON.stringify(request);
      this.transaction.sendTransactionOTP(json).subscribe(data => {
   
        console.log(data.Message);
        let code = this.EncrdecrService.getDecr(data.Refference_No);
        let id = code.split('|')[0];
        let SecreteCode = code.split('|')[2];
        // if (data.ID == 1 && id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value) {
        if (data.ID == 1 && id == "1" && SecreteCode == this.OTPForm.controls["OTP"].value) {
          this.Loader.hide();
          this.bsModalRef.content.onClose.next(true);
          this.bsModalRef.hide();
          this.ClearIntervalOTP();
        }
        else {
          this.Loader.hide();
          this.ngOtpInput.setValue('');;
          this.CallAlertModal("Invalid OTP Code");
        }
      });
    }

  }
  onOtpChange(e) {
    let val = e;
    let v = '';
    v = v + val;
    this.OTPForm.controls["OTP"].setValue(v);
  }
  ResendOTP() {
    // this.CallResendOTP.emit(true);
    this.ClearIntervalOTP();
    this.StartTimer();
    this.bsModalRef.content.action.next(true);
  }
  ValueMasking(value, Flag) {
    let MaskValue = "";
    if (Flag == "Mobile") {
      MaskValue = value.replace(/\d(?=\d{4})/g, "X");
    } else if (Flag == "Email") {
      let index = value.indexOf("@");
      MaskValue =
        value.substring(0, 2) +
        "XXXXXXXX" +
        value.substring(index, value.length); //- 1
    }
    return MaskValue;
  }
  CallAlertModal(msg: any) {
    $("#AlertModalprofilemodels").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContentmodels').text(msg);
  }
  StartTimer() {
    this.Loader.hide();
    $(".res").removeClass("act").prop("disabled", true);
    let t = this.OtpTimer;
    this.OTP_Timer_Function = setInterval(function () {
      //
      if (t >= 0) {
        const minutes = Math.floor(t / 60);
        let seconds: any = t % 60;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }

        $("#Time").text(`0${minutes}:${seconds}`);
        console.log($("#Time").val())
        
        if (t === 0) {
          $(".res").addClass("act").prop("disabled", false);
          clearInterval(this.OTP_Timer_Function);
        }
        t -= 1;
      }
    }, 1000);
  }
//Added by tishya 17/12/2024
splitPhoneNumber(phoneNumber: string) {
  if (phoneNumber.startsWith('+91')) {
    const countryCode = phoneNumber.slice(0, 3);  // Extract the +91 part
    const localNumber = phoneNumber.slice(3);     // Extract the remaining part
    return localNumber;
  }
}
}
